import React from 'react';
import ManufacturingHero from '../components/manufacturing/ManufacturingHero';
import ManufacturingGallery from '../components/manufacturing/ManufacturingGallery';
import AboutCTA from '../components/about/AboutCTA';

const Manufacturing = () => {
  return (
    <div className="pt-16">
      <ManufacturingHero />
      <ManufacturingGallery />
      <AboutCTA />
    </div>
  );
};

export default Manufacturing;
